import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DevelopersLayer from "../components/DevelopersLayer";

const DevelopersPage = () => {
  return (
    <>
      <Breadcrumb title="Developers" />
      <DevelopersLayer />
    </>
  );
};

export default DevelopersPage;